import React, { useRef } from "react";
import { Button, DatePicker, InputRef, Space } from "antd";
import { useTheme } from "react-jss";
import { GlobalToken } from "antd/es/theme/interface";
import { ColumnType } from "antd/es/table";
import { CalendarFilled, SearchOutlined } from "@ant-design/icons";
import moment from "moment";
import { RangePickerProps } from "antd/es/date-picker";
import dayjs from "dayjs";

export const useDatePickerColumn = <
  T extends object,
  S extends { page_number: number }
>(
  setSearchParams: React.Dispatch<React.SetStateAction<S>>
) => {
  const searchInput = useRef<InputRef>(null);
  const theme = useTheme<GlobalToken>();

  const disabledDate: RangePickerProps["disabledDate"] = (current) => {
    return current && current > moment().endOf("day");
  };

  const handleReset = (clearFilters: () => void, confirm: () => void) => {
    clearFilters();
    setSearchParams((prev) => ({
      ...prev,
      from_date: undefined,
      to_date: undefined,
      page_number: 1,
    }));
    confirm();
  };

  const getColumnDataPickerProps = (): ColumnType<T> => ({
    filterDropdown: ({
      selectedKeys,
      setSelectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <div style={{ marginBottom: ".5rem" }}>
          <DatePicker.RangePicker
            disabledDate={disabledDate}
            value={selectedKeys.map((val) => dayjs(val)) as any}
            style={{ width: "100%" }}
            onChange={(values) => {
              if (values && values[0] && values[1]) {
                setSelectedKeys([values[0].valueOf(), values[1].valueOf()]);
              } else {
                setSelectedKeys([]);
              }
            }}
          />
        </div>
        <Space>
          <Button
            type="primary"
            onClick={() => {
              const [start, end] = selectedKeys as number[];
              if (start && end) {
                setSearchParams((prev) => ({
                  ...prev,
                  from_date: dayjs(start)
                    .startOf("day")
                    .format("YYYY-MM-DDTHH:mm:ss"),
                  to_date: dayjs(end)
                    .endOf("day")
                    .format("YYYY-MM-DDTHH:mm:ss"),
                  page_number: 1,
                }));
              }
              confirm();
            }}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Искать
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters, confirm)}
            size="small"
            style={{ width: 90 }}
          >
            Сбросить
          </Button>
          <Button type="link" size="small" onClick={close}>
            Закрыть
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <CalendarFilled
        style={{ color: filtered ? theme.colorPrimary : undefined }}
      />
    ),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) setTimeout(() => searchInput.current?.select(), 100);
    },
  });

  return { getColumnDataPickerProps };
};
